import { mergeDeepObjects } from '@/plugins/helpers'

export const state = () => ({
  privacyAgreement: null,
  termsAndConditions: null,
  pricingTable: null,
  reference: null,
  data: {}
})

export const mutations = {
  setData(state, value) {
    state.data = value
  },
  setPrivacyAgreement(state, value) {
    state.privacyAgreement = value
  },
  setTermsAndConditions(state, value) {
    state.termsAndConditions = value
  },
  setPricingTable(state, value) {
    state.pricingTable = value
  },
  setContactDetails(state, value) {
    state.data.contact_details = value
  },
  setReference(state, value) {
    state.reference = value
  }
}

export const actions = {
  resetData({ state, commit }) {
    commit('setData', {})
    commit('postal/setData', {}, { root: true })
  },
  setData({ state, commit, dispatch }, value) {
    if (value) {
      commit('setData', mergeDeepObjects(false, state.data, value))
      dispatch('postal/setData', value, { root: true })
    }
  },
  async getContactDetails({ commit }) {
    const result = await this.$storage.getUniversal('account')

    const contactDetails = {
      first_name: result?.customer_details?.first_name,
      last_name: result?.customer_details?.last_name,
      email_address: result?.customer_details?.email,
      phone_number: result?.customer_details?.phone_number
    }

    commit('setContactDetails', contactDetails)
  },
  async getLegalTexts({ commit, state, rootState }) {
    const professionalId = rootState.postal?.platform?.professionalId
    if (state.data?.installation_id && state.data?.type) {
      const result = await this.$marlonApi.getLegalTexts(
        professionalId,
        state.data.installation_id,
        state.data?.type,
        rootState.index?.customerPwa
      )

      if (result?.success) {
        commit('setPrivacyAgreement', result.privacy_policy)
        commit('setTermsAndConditions', result.terms_of_use)
        commit('setPricingTable', result.pricing_info)
      }
    }
  },
  async confirmRequestForAssistance({ state, commit, rootState }) {
    const body = { ...state.data }
    delete body._date_visit
    delete body._termsandconditions
    delete body._charged
    const result = await this.$marlonApi.requestAssistance(
      body,
      rootState.index?.customerPwa
    )
    if (result?.success) {
      commit('setReference', result?.reference)
      return true
    }

    return false
  },
  async getInstallationDetail({ dispatch, rootState }) {
    const currentInstallation = await dispatch(
      'installation/getCurrent',
      null,
      { root: true }
    )

    const postalInstallationId = rootState.postal.data.installation_id
    const isCustomerPwa = rootState.index?.customerPwa
    if (!currentInstallation && postalInstallationId && isCustomerPwa) {
      const installationDetail = await this.$marlonApi.installationDetail(
        postalInstallationId
      )
      const { installation } = installationDetail
      await dispatch('installation/setCurrent', installation, { root: true })
      return installation
    }
    return currentInstallation
  }
}
